// Country flag emoji mapping for African national teams
const TEAM_FLAGS = {
  'nigeria': '\u{1F1F3}\u{1F1EC}',
  'egypt': '\u{1F1EA}\u{1F1EC}',
  'senegal': '\u{1F1F8}\u{1F1F3}',
  'ghana': '\u{1F1EC}\u{1F1ED}',
  'cameroon': '\u{1F1E8}\u{1F1F2}',
  'morocco': '\u{1F1F2}\u{1F1E6}',
  'algeria': '\u{1F1E9}\u{1F1FF}',
  'tunisia': '\u{1F1F9}\u{1F1F3}',
  'ivory coast': '\u{1F1E8}\u{1F1EE}',
  "côte d'ivoire": '\u{1F1E8}\u{1F1EE}',
  'south africa': '\u{1F1FF}\u{1F1E6}',
  'mali': '\u{1F1F2}\u{1F1F1}',
  'burkina faso': '\u{1F1E7}\u{1F1EB}',
  'guinea': '\u{1F1EC}\u{1F1F3}',
  'congo': '\u{1F1E8}\u{1F1EC}',
  'dr congo': '\u{1F1E8}\u{1F1E9}',
  'tanzania': '\u{1F1F9}\u{1F1FF}',
  'kenya': '\u{1F1F0}\u{1F1EA}',
  'uganda': '\u{1F1FA}\u{1F1EC}',
  'zambia': '\u{1F1FF}\u{1F1F2}',
  'zimbabwe': '\u{1F1FF}\u{1F1FC}',
  'mozambique': '\u{1F1F2}\u{1F1FF}',
  'angola': '\u{1F1E6}\u{1F1F4}',
  'ethiopia': '\u{1F1EA}\u{1F1F9}',
  'sudan': '\u{1F1F8}\u{1F1E9}',
  'libya': '\u{1F1F1}\u{1F1FE}',
  'gabon': '\u{1F1EC}\u{1F1E6}',
  'benin': '\u{1F1E7}\u{1F1EF}',
  'togo': '\u{1F1F9}\u{1F1EC}',
  'niger': '\u{1F1F3}\u{1F1EA}',
  'rwanda': '\u{1F1F7}\u{1F1FC}',
  'namibia': '\u{1F1F3}\u{1F1E6}',
  'cape verde': '\u{1F1E8}\u{1F1FB}',
  'mauritania': '\u{1F1F2}\u{1F1F7}',
  'equatorial guinea': '\u{1F1EC}\u{1F1F6}',
  'comoros': '\u{1F1F0}\u{1F1F2}',
  'gambia': '\u{1F1EC}\u{1F1F2}',
  'sierra leone': '\u{1F1F8}\u{1F1F1}',
  'liberia': '\u{1F1F1}\u{1F1F7}',
  'madagascar': '\u{1F1F2}\u{1F1EC}',
  'botswana': '\u{1F1E7}\u{1F1FC}',
  'malawi': '\u{1F1F2}\u{1F1FC}',
  'south sudan': '\u{1F1F8}\u{1F1F8}',
};

// Get flag emoji for a team name
export const getTeamFlag = (teamName) => {
  if (!teamName) return null;
  const lower = teamName.trim().toLowerCase();
  return TEAM_FLAGS[lower] || null;
};

// Parse "TeamA vs TeamB" into structured data with flags
export const parseTeamsWithFlags = (teamsString) => {
  if (!teamsString) return null;
  
  const separators = [' vs ', ' vs. ', ' v ', ' - '];
  let home = null;
  let away = null;
  
  for (const sep of separators) {
    if (teamsString.toLowerCase().includes(sep)) {
      const parts = teamsString.split(new RegExp(sep, 'i'));
      if (parts.length === 2) {
        home = parts[0].trim();
        away = parts[1].trim();
        break;
      }
    }
  }
  
  if (!home || !away) return null;
  
  return {
    home: { name: home, flag: getTeamFlag(home) },
    away: { name: away, flag: getTeamFlag(away) },
  };
};

export default TEAM_FLAGS;
